import KatalLogger, { Level } from '@amzn/katal-logger';
import type { LoggerConfig } from '@amzn/katal-logger';

const getLogger = (): KatalLogger => {
  const config: LoggerConfig = {
    url: '/learn/logs/seller-university-website',
    logThreshold: Level.INFO,
    maxLogLineSize: 100000,
    logToConsole: false,
    decodeStackTrace: true,
  };
  const loggerClient = new KatalLogger(config);
  loggerClient.addErrorListener();
  loggerClient.addPerformanceListener();
  return loggerClient;
};

const clientLogger: KatalLogger = getLogger();
export default clientLogger;
